const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCheckFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#319300",
    style: {
      fill: "#319300",
      fill: "color(display-p3 0.1922 0.5765 0.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5753_113175",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 16,
    height: 16,
    fill: "#D9D9D9",
    style: {
      fill: "#D9D9D9",
      fill: "color(display-p3 0.8510 0.8510 0.8510)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5753_113175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.36518 12.1L14.0152 6.45C14.1485 6.31667 14.3041 6.25 14.4818 6.25C14.6596 6.25 14.8152 6.31667 14.9485 6.45C15.0818 6.58333 15.1485 6.74167 15.1485 6.925C15.1485 7.10833 15.0818 7.26667 14.9485 7.4L8.83184 13.5333C8.69851 13.6667 8.54296 13.7333 8.36518 13.7333C8.1874 13.7333 8.03184 13.6667 7.89851 13.5333L5.03184 10.6667C4.89851 10.5333 4.83462 10.375 4.84018 10.1917C4.84573 10.0083 4.91518 9.85 5.04851 9.71667C5.18184 9.58333 5.34018 9.51667 5.52351 9.51667C5.70684 9.51667 5.86518 9.58333 5.99851 9.71667L8.36518 12.1Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckFill);
export default __webpack_public_path__ + "static/media/icon_check_fill.33298ea706910006a35a43ba804a00c5.svg";
export { ForwardRef as ReactComponent };